module.exports = __webpack_public_path__ + "images/emoji/arrow_down.c67cd5921aa7fdedccd9.png";